/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const searchRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'search',
  auth: 'external',
  fingerprint: 'Il06JHlDHVL3OqBlPNZhM5wP6LXzGzX8',
  na1Only: false
};
export const getSearchFilterDefinitionsRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'getSearchFilterDefinitions',
  auth: 'external',
  fingerprint: 'KmIdoIswThFblI0n6gkSc5wP6LXzGzX8',
  na1Only: false
};
export const getSuggestionSectionsRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'getSuggestionSections',
  auth: 'external',
  fingerprint: 'U91yJCef9mF8YtaS_zPrmZwP6LXzGzX8',
  na1Only: false
};